import React from 'react'
// nodejs library that concatenates classes
import classNames from 'classnames'
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles'

// @material-ui/icons
import LocationOnIcon from '@material-ui/icons/LocationOn'
import PhoneIcon from '@material-ui/icons/Phone'
import EmailIcon from '@material-ui/icons/Email'

// core components
import GridContainer from 'components/Grid/GridContainer.js'
import GridItem from 'components/Grid/GridItem.js'
import Card from 'components/Card/Card.js'

import styles from 'assets/jss/material-kit-react/views/contactPageSections/contactStyle.js'

import qrcode from 'assets/img/qrcode.jpg'

const useStyles = makeStyles(styles)

export default function TeamSection() {
  const classes = useStyles()
  const imageClasses = classNames(classes.imgRaised, classes.imgRounded, classes.imgFluid)
  return (
    <div className={classes.section}>
      <h2 className={classes.title}>联系方式</h2>
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={4}>
            <Card plain>
              <GridItem xs={12} sm={12} md={6} className={classes.itemGrid}>
                <img src={qrcode} alt="微信公众号" className={imageClasses} />
              </GridItem>
              <h4 className={classes.cardTitle}>微信公众号：江苏硕佰</h4>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={8}>
            <Card plain>
              <GridItem className={classes.itemFlex}>
                <LocationOnIcon className={classes.icons} />
                <div className={classes.typo}>联系地址：南京江北新区研创园景枫乐创中心A1栋13楼</div>
              </GridItem>
            </Card>
            <Card plain>
              <GridItem className={classes.itemFlex}>
                <PhoneIcon className={classes.icons} />
                <div className={classes.typo}>联系电话：025-87797766(18068801555)</div>
              </GridItem>
            </Card>
            <Card plain>
              <GridItem className={classes.itemFlex}>
                <EmailIcon className={classes.icons} />
                <div className={classes.typo}>
                  公司邮箱：<a href="mailto:jsbtc_nanjing@163.com">jsbtc_nanjing@163.com</a>
                </div>
              </GridItem>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  )
}
